import React, { useMemo, useEffect } from 'react';
import Head from 'next/head';

var HubspotForm = function HubspotForm(_ref) {
  var region = _ref.region,
    portalId = _ref.portalId,
    formId = _ref.formId,
    sfdcCampaignId = _ref.sfdcCampaignId;
  var formWrapperId = useMemo(function () {
    return ("hubspot-form-" + portalId + "-" + formId).replace(/[^a-zA-Z0-9-]/g, '-');
  }, [portalId, formId]);
  useEffect(function () {
    var createForm = function createForm() {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: region,
          portalId: portalId,
          formId: formId,
          target: "#" + formWrapperId,
          sfdcCampaignId: sfdcCampaignId
        });
      }
    };
    if (window.hbspt) {
      createForm();
    } else {
      var script = document.getElementById('hs-forms-v2');
      if (script) {
        script.onload = createForm;
      }
    }
  }, [region, portalId, formId, sfdcCampaignId, formWrapperId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("script", {
    id: "hs-forms-v2",
    src: "https://js.hsforms.net/forms/v2.js",
    async: true
  })), /*#__PURE__*/React.createElement("div", {
    id: formWrapperId
  }));
};
var HubspotForm$1 = HubspotForm;

export { HubspotForm$1 as default };
